import { render } from "./detailCrawler.vue?vue&type=template&id=b44fe60a&ts=true"
import script from "./detailCrawler.vue?vue&type=script&lang=ts"
export * from "./detailCrawler.vue?vue&type=script&lang=ts"

import exportComponent from "/home/kuradmin/dev-frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__